module.exports = __webpack_public_path__ + "img/photo_230490689.0e5c84dc.png";